import React from 'react';
import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonImg
} from '@ionic/react';
import { ChangePasswordForm } from '../components/auth/components/ChangePasswordForm';
import { CenteredPageContent } from '../components/layout/CenteredPageContent';

export const ChangePassword: React.FC = () => {
    return (
        <CenteredPageContent maxWidth="md">
            <IonCard>
                {/* Logo */}
                <IonImg
                    src="/logo.png"
                    alt="LinkSharePro Logo"
                    style={{
                        width: '200px',
                        margin: '2rem auto'
                    }}
                />

                <IonCardHeader>
                    <IonCardTitle className="ion-text-center">Change Password</IonCardTitle>
                </IonCardHeader>

                <IonCardContent>
                    <ChangePasswordForm />
                </IonCardContent>
            </IonCard>
        </CenteredPageContent>
    );
}; 